import styled from "styled-components/macro";

export const FormContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-gap: 2rem;
`;

export const TestVersion = styled.div`
  max-width: 288px;
`;
